import React from 'react';

// Types
import { Attachment } from 'Shared/types/Attachment.type';

// Styles
import './ImageViewer.scss';

type Props = {
  attachment: Attachment;
};

const ImageViewer = ({ attachment }: Props) => {
  const baseClassName = 'ImageViewer';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__wrapper`}>
        <img src={attachment.url} alt={attachment.fileName} className={`${baseClassName}__wrapper__img`} />
      </div>
    </div>
  );
};

export default ImageViewer;
